import { Injectable } from '@angular/core';
import { CalAngularService } from '@cvx/cal-angular';
import { BehaviorSubject } from 'rxjs';
import { LoginUser } from '../_models';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  
  loggedUserDetails = new BehaviorSubject<LoginUser[]>([]);
  
  constructor(
   
    private authService: CalAngularService  ) {}

  getAccessToken() {
    this.authService.getAADToken().subscribe((result) => {
    localStorage.setItem('token', JSON.parse(JSON.stringify(result)));
      while (localStorage.getItem('token') === undefined) {
        localStorage.setItem('token', JSON.parse(JSON.stringify(result)));
      }
    });
  }

  getUserDetail(value: LoginUser[]) {
    this.loggedUserDetails.next(value);
  }
}
